// src/Components/VmList/component.jsx
import React, { useState } from 'react';
import { Container,    useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import QrScanner from './Qr';
import locationImage from '../../assets/Person.png';
import { toast } from 'react-toastify';


import { useNavigate } from "react-router-dom";

import Webcam from "react-webcam";
import QrReader from "react-web-qr-reader";


import close from '../../assets/close.png';
import location_banner from '../../assets/location_banner.png';
import QrMark from '../../assets/qrmark.png';

import {
  AppBar,
  Box,
  Button,
  Toolbar,
  Typography,
  CircularProgress,
} from '@mui/material';
import LocationHeader from './LocationHeader';
import QRModal from './Qr';


const LocationPage = ({fetchVmList, setshowLoction}) => {
  const theme = useTheme();
  const isSmallDevice = useMediaQuery(theme.breakpoints.down('sm'));
  const [location_Btn_disable,setLocation_Btn_disable]=useState(false)
  const [qrModelflag,setQrModelflag]=useState(false)

  const handleLocationAccess = () => {
    //console.log("Location access triggered");

    getLocation4Modal();
  };

  const showError = (error) => {
     setLocation_Btn_disable(false)
    let message = '';
    switch (error.code) {
      case error.PERMISSION_DENIED:
        message = 'User denied the request for Geolocation.';
        setshowLoction(false)
        break;
      case error.POSITION_UNAVAILABLE:
        message = 'Location information is unavailable.';
         setshowLoction(false)
        break;
      case error.TIMEOUT:
        message = 'The request to get user location timed out.';
         setshowLoction(false)
        break;
      case error.UNKNOWN_ERROR:
      default:
         setshowLoction(false)
        message = 'An unknown error occurred.';
    }

    toast.error(message, {
      position: "top-right",
      autoClose: 1500,
    });
  };

  const getLocation4Modal = () => {
    setLocation_Btn_disable(true)
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(showPosition, showError);
    } else {
      toast.error('Geolocation is not supported by this browser.', {
       position: "top-right",
        autoClose: 1500,
      });
       setLocation_Btn_disable(false)
    }

    function showPosition(position) {
      localStorage.setItem('lat', position.coords.latitude);
      localStorage.setItem('lng', position.coords.longitude);
      fetchVmList( position.coords.latitude,position.coords.longitude)
     
    }
  };

  const CloseQrFun=(e)=>{
setQrModelflag(false)
  }
  return (
    <>
{qrModelflag?<QRModal qrModelflag={qrModelflag} CloseQrFun={CloseQrFun}/>:
    <>
    <LocationHeader/>
    <Container
      maxWidth="sm"
      sx={{
        pt: isSmallDevice ? 6 : 8,
        pb: 10,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '100vh',
        textAlign: 'center',
      }}
    >
          <Typography
          style={{marginBottom:"50px"}}
        variant="h6"
        fontWeight="bold"
        gutterBottom
        sx={{ fontSize: isSmallDevice ? '1.1rem' : '1.25rem', }}
      >
        Request for Location Access
      </Typography>
      {/* Image */}
      <Box sx={{ mb: 4, display: 'flex', justifyContent: 'center' }}>
        <img
          src={locationImage}
          alt="Location access"
          style={{
            width: isSmallDevice ? '70%' : '60%',
            maxWidth: '280px',
            height: 'auto',
          }}
        />
      </Box>

      {/* Heading */}
  

      <Typography
        variant="body1"
        color="text.secondary"
        sx={{ mb: 3, px: isSmallDevice ? 1 : 3 }}
      >
        We need to know your location to find nearby vending machines.
      </Typography>



      
                {location_Btn_disable?
                
                
                <Button
                    variant="contained"
                    sx={{height:"49px", marginTop: { xs: '10%', md: '0%' }, width: '100%', backgroundColor: 'rgb(188, 189, 189)' }}
                    onClick={"handleButtonClick"}
                >
                    <CircularProgress style={{ color: "green" ,width:"28px",height:"28px"}} />
                </Button>:   <Button
                    variant="contained"
                    sx={{ height:"49px",marginTop: { xs: '10%', md: '0%' }, width: '100%', background: 'rgba(0, 177, 119, 1)' }}
                    onClick={handleLocationAccess}
                >
                   <Typography fontWeight={600} fontSize={"12px"}> Enable location access</Typography>
                </Button>}
                <Typography  fontSize={"14px"}  fontWeight={400} textAlign={"center"} marginTop={"10px"} color={"rgba(148, 163, 184, 1)"}>or</Typography>
                <Typography fontSize={"13px"} fontWeight={400} textAlign={"center"} marginTop={"10px"} marginBottom={"10px"} color={"rgba(148, 163, 184, 1)"}> scan Qr Code to see the products</Typography>
               <Box sx={{display:"flex"}} justifyContent={"center"}>
                <Box /*  onClick={(e)=>{ShowQrModalFun(e)}} */ sx={{display:"flex",backgroundColor: "rgb(255 255 255)",width:"79px",height:"77px",borderRadius:"10px",boxShadow:"0px 4px 17px 0px rgba(148, 163, 184, 0.54)"}} justifyContent="center" alignItems={"center"} marginTop={{ xs: '5%', md: '0%' }}>
                <img
                onClick={()=>{setQrModelflag(true)}}
                        src={QrMark} 
                        alt="Your Image Alt Text"
                        style={{ width: '52px', maxWidth: '600px', padding: "5%" }} // Adjust the width as needed
                    />
                </Box>
                </Box>

  

  
    </Container>
    </>
}
    </>
  );
};

export default LocationPage;
